import {
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from "reactstrap";
import { P } from "AbstractElements";
import Moment from "moment";
import "moment/locale/id";

const RespondentDetailModal = ({
	isOpen,
	onClose,
	detail,
	isLoading,
	error,
}) => {
	const shortAnswers = detail?.answers?.filter((item) => !item.isEssay) ?? [];
	const essayAnswers = detail?.answers?.filter((item) => item.isEssay) ?? [];

	return (
		<Modal isOpen={isOpen} toggle={onClose} size="lg" centered scrollable>
			<ModalHeader toggle={onClose}>
				Detail Jawaban Survey
				{detail?.name ? ` — ${detail.name}` : ""}
			</ModalHeader>
			<ModalBody>
				{isLoading && (
					<div className="text-center py-4">
						<Spinner color="primary" />
					</div>
				)}

				{error && !isLoading && (
					<div className="rounded-3 border border-danger-subtle bg-danger-subtle p-3">
						<P className="mb-0 text-danger">
							{typeof error === "string" ? error : "Gagal memuat detail responden."}
						</P>
					</div>
				)}

				{detail && !isLoading && (
					<>
						<div className="rounded-3 border bg-light p-3 mb-3">
							<div className="small text-muted mb-1">Responden</div>
							<div className="fw-semibold text-dark">{detail.name}</div>
							<div className="text-muted">{detail.email}</div>
							{detail.submittedAt && (
								<div className="small text-muted mt-2">
									Terakhir survey:{" "}
									{Moment(detail.submittedAt).locale("id").format("dddd, DD MMM YYYY HH:mm")}
								</div>
							)}
						</div>

						{shortAnswers.length > 0 && (
							<div className="mb-4">
								<h6 className="fw-semibold mb-3">Rating &amp; Pilihan (Q1–Q7)</h6>
								<div className="d-flex flex-column gap-2">
									{shortAnswers.map((item) => (
										<div
											key={item.code}
											className="rounded-3 border p-3 bg-white d-flex flex-column flex-md-row gap-1 gap-md-3"
										>
											<div className="flex-grow-1 small text-muted">{item.title}</div>
											<div className="fw-semibold text-dark text-md-end" style={{ minWidth: 120 }}>
												{item.displayAnswer}
											</div>
										</div>
									))}
								</div>
							</div>
						)}

						{essayAnswers.length > 0 && (
							<div>
								<h6 className="fw-semibold mb-3">Essay (Q8–Q10)</h6>
								{essayAnswers.map((item, index) => (
									<div key={item.code} className="mb-3">
										<div className="fw-semibold mb-1">
											{index + 1}. {item.title}
										</div>
										<div
											className="rounded-3 border p-3 bg-white"
											style={{ whiteSpace: "pre-wrap", minHeight: 72 }}
										>
											{item.displayAnswer?.trim() ? item.displayAnswer : "-"}
										</div>
									</div>
								))}
							</div>
						)}
					</>
				)}
			</ModalBody>
		</Modal>
	);
};

export default RespondentDetailModal;
